import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";
import { useNotification, useTranslate } from "@refinedev/core";

interface CopyTextButtonProps {
  text: string;
}

export function CopyTextButton({ text }: CopyTextButtonProps) {
  const translate = useTranslate();
  const { open } = useNotification();
  const label = translate("erp_integrations.actions.copy");

  const handleCopy = async () => {
    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);
      open?.({ type: "success", message: translate("erp_integrations.actions.copied") });
    } catch {
      open?.({ type: "error", message: label });
    }
  };

  return (
    <Tooltip title={label}>
      <span>
        <IconButton
          type="button"
          size="small"
          aria-label={label}
          disabled={!text}
          onClick={handleCopy}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
